import { NgModule } from "@angular/core";
import { AlertIconComponent } from "./alert-icon/alert-icon.component";
import { BrokenImageIconComponent } from "./broken-image-icon/broken-image-icon.component";
import { CaretIconComponent } from "./caret-icon/caret-icon.component";
import { ChevronIconComponent } from "./chevron-icon/chevron-icon.component";
import { ClipboardIconComponent } from "./clipboard-icon/clipboard-icon.component";
import { CloseIconComponent } from "./close-icon/close-icon.component";
import { ExternalLinkIconComponent } from "./external-link-icon/external-link-icon.component";
import { HelpIconComponent } from "./help-icon/help-icon.component";
import { ResetIconComponent } from "./reset-icon/reset-icon.component";

const ICON_COMPONENTS = [
    AlertIconComponent,
    BrokenImageIconComponent,
    CaretIconComponent,
    ChevronIconComponent,
    ClipboardIconComponent,
    CloseIconComponent,
    ExternalLinkIconComponent,
    HelpIconComponent,
    ResetIconComponent
];

@NgModule({
    imports: ICON_COMPONENTS,
    exports: ICON_COMPONENTS
})
export class GeneAiIconModule {}
